import React, { cloneElement, isValidElement } from 'react';
import { Draggable } from 'react-beautiful-dnd';

import classNames from 'classnames';

import { SatCoreRegister } from '../SatCoreRegistry';

const ReactBeautifulDndDraggable = ({
  enabled,
  draggableId,
  index,
  children,
  isDragDisabled = false
} = {}) => {
  // if drag-drop is not enabled, just render children as-is
  if (!enabled) {
    return children;
  }
  // else if enabled, wrap with draggable
  return (
    <Draggable
      draggableId={draggableId}
      index={index}
      isDragDisabled={isDragDisabled}>
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={classNames('draggable-item', {
              dragging: snapshot.isDragging
            })}>
            {isValidElement(children) ? (
              cloneElement(children, {
                dragHandleProps: provided.dragHandleProps,
                isDragging: snapshot.isDragging
              })
            ) : children}
          </div>
        );
      }}
    </Draggable>
  );
};

SatCoreRegister('ReactBeautifulDndDraggable', ReactBeautifulDndDraggable);

export default ReactBeautifulDndDraggable;
